import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";
import LanguageSwitcher, { TranslateInit } from "@/components/LanguageSwitcher";
import Header from "@/components/Layout/Header";
import Footer from "@/components/Layout/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Account from "@/pages/Account";
import QRVerify from "@/pages/QRVerify";
import OrderConfirm from "@/pages/OrderConfirm";
import { Login, Register } from "@/pages/Auth";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import StaffAdmin from "@/pages/admin/StaffAdmin";
import POS from "@/pages/admin/POS";
import QRAdmin from "@/pages/admin/QRAdmin";
import { InventoryAdmin, CustomersAdmin, AuditLogs, Coupons } from "@/pages/admin/OtherAdmin";
import InvoicePage from "@/pages/admin/Invoice";
import InvoicesAdmin from "@/pages/admin/InvoicesAdmin";
import PaymentsAdmin from "@/pages/admin/PaymentsAdmin";
import SaleAdmin from "@/pages/admin/SaleAdmin";
import EmiAdmin from "@/pages/admin/EmiAdmin";
import ReviewsAdmin from "@/pages/admin/ReviewsAdmin";
import EPicAdmin from "@/pages/admin/EPicAdmin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}

function Story() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-24 fade-up">
      <p className="eyebrow">Our Story</p>
      <h1 className="font-serif text-4xl md:text-6xl mt-4">A House Rooted in Indian Craft.</h1>
      <p className="mt-8 text-[#55524D] leading-relaxed">LEE BAG began with a simple belief — that Indian leather, shaped by centuries of craft, deserved a stage as considered as any European maison. Every piece is cut, stitched, and finished by a single artisan whose signature travels with the bag, verified through a unique QR certificate.</p>
      <p className="mt-6 text-[#55524D] leading-relaxed">From our Delhi atelier to your everyday, we make heirlooms — not accessories.</p>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TranslateInit />
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/verify/:token" element={<QRVerify />} />
            <Route path="/admin/login" element={<Login admin />} />
            <Route path="/admin/invoice/:id" element={<InvoicePage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="inventory" element={<InventoryAdmin />} />
              <Route path="orders" element={<OrdersAdmin />} />
              <Route path="invoices" element={<InvoicesAdmin />} />
              <Route path="pos" element={<POS />} />
              <Route path="customers" element={<CustomersAdmin />} />
              <Route path="staff" element={<StaffAdmin />} />
              <Route path="qr" element={<QRAdmin />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="payments" element={<PaymentsAdmin />} />
              <Route path="sale" element={<SaleAdmin />} />
              <Route path="emi" element={<EmiAdmin />} />
              <Route path="reviews" element={<ReviewsAdmin />} />
              <Route path="epics" element={<EPicAdmin />} />
              <Route path="audit" element={<AuditLogs />} />
            </Route>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/account" element={<Account />} />
              <Route path="/order/:id" element={<OrderConfirm />} />
              <Route path="/story" element={<Story />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
export default App;
